import {
  RawDraftContentState,
  RawDraftContentBlock,
  RawDraftEntityRange,
} from 'draft-js';

export type Entity = {
  id?: string;
  title: string;
  color: string;
};

export type Tag = {
  text: string;
  offset: number;
  length: number;
  entityId?: string;
};

export class Intent {
  id?: string;
  title: string;
  expressions: Array<Expression>;

  constructor(title: string, expressions: Array<Expression>){
    this.title = title;
    this.expressions = expressions;
  }
};

export class Expression {
  id?: string;

  text: string = '';

  tags: Array<Tag> = [];

  constructor(data: RawDraftContentState) {
    data.blocks.map((block: RawDraftContentBlock) => {
      this.text += block.text;
      block.entityRanges.map((entityRange: RawDraftEntityRange, index: number) => {
        const tag: Tag = {
          text: this.text.substring(
            entityRange.offset,
            entityRange.offset + entityRange.length,
          ),
          offset: entityRange.offset,
          length: entityRange.length,
          entityId: data.entityMap[index]?.data?.entityId,
        };
        this.tags.push(tag);
      });
    });
  }
}

export interface IntentState {
  intents: Intent[];
}

export interface EntityState {
  entities: Entity[];
}
